import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import CompanyStory from './components/CompanyStory';
import ValuesGrid from './components/ValuesGrid';
import TeamSection from './components/TeamSection';
import CredentialsSection from './components/CredentialsSection';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'About NS Electrical WA | Licensed Commercial Electrician Perth';
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <AboutHero />
        <CompanyStory />
        <ValuesGrid />
        <TeamSection />
        <CredentialsSection />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;